import { ConnectedPosition } from '@angular/cdk/overlay';
import { Component, Input, OnInit } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { combineLatest, firstValueFrom, Subject, timer } from 'rxjs';
import { startWith, takeUntil } from 'rxjs/operators';
import { AppService } from 'src/app/app.service';
import { SendbirdChatService } from 'src/app/layouts/sendbird-chat/sendbird-chat.service';
import { CardCenterService } from 'src/app/pages/card-center/card-center.service';
import { LoginService } from 'src/app/pages/login-dialog/login.service';
import { NotificationDialogService } from 'src/app/pages/notification-center/dialog/notification-dialog.service';
import { NotificationService } from 'src/app/pages/notification-center/notification.service';
import { MenuItem, orderMenu, TopMenu } from 'src/app/pages/user-center/left-menu.config';
import { SettingsApi } from 'src/app/shared/apis/settings.api';
import { AccountInforData } from 'src/app/shared/interfaces/account.interface';
import { ChatService } from 'src/app/shared/service/chat.service';
import { LayoutService } from 'src/app/shared/service/layout.service';
@UntilDestroy()
@Component({
  selector: 'app-top-bar',
  templateUrl: './top-bar.component.html',
  styleUrls: ['./top-bar.component.scss'],
})
export class TopBarComponent implements OnInit {
  constructor(
    public appService: AppService,
    public loginService: LoginService,
    public chatService: ChatService,
    private layout: LayoutService,
    private notificationService: NotificationService,
    private cardCenterService: CardCenterService,
    public notificationDialogService: NotificationDialogService,
    private sendbirdChatService: SendbirdChatService,
    private settingsApi: SettingsApi,
  ) {}

  showPop$: Subject<boolean> = new Subject();
  popStatus: { [key: string]: boolean } = {
    user: false,
    wallet: false,
    order: false,
    notification: false,
    download: false,
    imchat: false,
  };

  containerPositions: ConnectedPosition[] = [
    { originX: 'end', originY: 'bottom', overlayX: 'end', overlayY: 'top', offsetX: 0, offsetY: -8 },
  ];
  loading: boolean = false;
  isSimple!: boolean;
  isH5!: boolean;
  userInfo?: AccountInforData;
  logined!: boolean; //是否登陆状态
  currentVipLevel: number = 0; //当前vip等级
  isSuperVip: boolean = false;
  orderMenuData = orderMenu;

  menuData = TopMenu.flat();

  messagesCount: number = 0; // 当前有多少信息未读
  isShowNoMsg: boolean = true;
  transactionMsgCount: number = 0; // 紀錄交易紀錄訊息數量變動
  isFirst: boolean = true; // 是否第一次加载
  @Input() vipLoading!: boolean;

  /**@bounsCount 卡券数量 */
  bounsCount: number = 0;

  ngOnInit() {
    this.appService.userInfo$.pipe(untilDestroyed(this)).subscribe((x: AccountInforData | null) => {
      this.userInfo = x ?? ({} as any);
      this.logined = !!x;
      if (!x?.isSvip) {
        this.currentVipLevel = x?.viPGrade ?? 0;
      }
      this.isSuperVip = x?.isSvip ?? false;

      // 判断国家开启自我约束功能
      this.menuData.forEach(e => {
        if (e.showOnlyCountry && (this.userInfo?.areaCode == '+599' || this.appService.countryCode == 'CW')) {
          e.showOnlyCountry = false;
        }
      });

      combineLatest([this.appService.noticeCounts$, this.appService.updateNoticeCounts$.pipe(startWith(true))])
        .pipe(untilDestroyed(this))
        .subscribe(async ([e, _]) => {
          if (!this.logined) {
            this.messagesCount = 0;
            return;
          }
          const config = await firstValueFrom(this.settingsApi.getNoticeConfig());
          const noticeTypeList: any[] = config?.data?.noticeTypeList || [];
          const total = noticeTypeList.reduce((acc, item) => {
            return acc + (e?.[item] || 0);
          }, 0);
          this.messagesCount = total || 0;

          if (this.messagesCount === 0) {
            this.notificationService.isReadedAll$.next(true);
          } else {
            this.notificationService.isReadedAll$.next(false);
          }
        });

      // 获取站内信 所有信息
      if (this.logined) {
        this.notificationService.getNoticeCounts();
      }
    });

    this.layout.page$.pipe(untilDestroyed(this)).subscribe(e => {
      this.isSimple = ['register', 'login', 'password'].includes(e);
      this.closePop();
    });

    this.layout.isH5$.pipe(untilDestroyed(this)).subscribe(e => (this.isH5 = e));

    this.cardCenterService.bounsCount$.pipe(untilDestroyed(this)).subscribe(bounsCount => {
      this.bounsCount = bounsCount || 0;
    });
  }

  handleClick(item: MenuItem): void {
    if (item.title == 'online_cs') {
      this.appService.toOnLineService$.next(true);
    }

    switch (item.icon) {
      case 'logout-right-filled':
        this.logout();
        break;

      case 'bell-filled':
        this.notificationDialogService.openNotification(1);
        break;

      default:
        break;
    }
  }

  //登出
  logout() {
    this.appService.saveUrl();
    this.appService.logoutSubject$.next(true);
  }

  showPop(v: string, skipRepeat: boolean = true) {
    if (skipRepeat && this.popStatus[v]) return;
    this.closePop();
    this.chatService.toggleChat(this.isH5, false);
    this.showPop$.next(true);
    this.popStatus[v] = true;
  }

  closePop(time: number = 0) {
    if (time > 0) {
      timer(time)
        .pipe(takeUntil(this.showPop$))
        .subscribe(() => {
          Object.keys(this.popStatus).forEach(x => (this.popStatus[x] = false));
        });
    } else {
      Object.keys(this.popStatus).forEach(x => (this.popStatus[x] = false));
    }
  }

  closeDialog: any;
  isActiveNoticeIdx: number = 0;
  isLoadNotice: boolean = true;

  openChat() {
    this.sendbirdChatService.toggleChat();
  }
}
